import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import Logo from '../assets/Logo.png';
import MenubarIcon from '../assets/Icon (1).png';

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate(); // Initialize useNavigate

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const hideAuthButtons = 
    location.pathname === '/booking-fee' || 
    location.pathname === '/booking-confirmed' || 
    location.pathname === '/address' ||
    location.pathname === '/care-flow/estimated-price' ||
    location.pathname === '/';

  const handleLogoClick = () => {
    navigate('/'); // Navigate to home page
  };

  return (
    <div className='pt-5 z-[100]'>
      <div className="flex shadow items-center justify-between bg-white border-b border-transparent rounded-lg lg:rounded-full sm:mx-[30px] mx-[20px] px-4 py-[20px] lg:px-8">
        <div className="flex items-center gap-4 lg:gap-10">
          <img 
            src={Logo} 
            alt="Logo" 
            className="h-8 cursor-pointer" // Add cursor pointer
            onClick={handleLogoClick} // Add onClick handler
          />
          <nav className="hidden lg:flex gap-4 lg:gap-12">
            <Link to="/repair-gadget" className={`text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6 ${location.pathname === '/repair-gadget' ? 'font-bold' : ''}`}>
              Repair 
            </Link>
            {/* <Link to="/care-flow" className={`text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6 ${location.pathname === '/care-flow' ? 'font-bold' : ''}`}>
              Care 
            </Link> */}
            <a href="https://www.gadgetsreborn.store/pages/about-us" className="text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6">About Us</a>
            {/* <a href="/contact-us" className="text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6">Contact Us</a> */}
            <Link to="/contact-us" className="text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6">Contact Us</Link> {/* Updated to Link */}

          </nav>
        </div>
        <div className="flex items-center">
          {!hideAuthButtons && (
            <div className='hidden lg:flex items-center gap-8'>
              {/* <a href="#login" className="text-[#475467] font-plus-jakarta-sans text-sm font-semibold lg:text-base leading-6">Log in</a>
              <a href="#signup" className="bg-yellow-400 font-plus-jakarta-sans font-semibold text-black text-sm lg:text-base leading-6 py-[10px] px-4 rounded-xl">Sign up</a> */}
            </div>
          )}
          <div className="lg:hidden flex items-center">
            <button className="text-[#475467] focus:outline-none" onClick={toggleDrawer}>
              <img src={MenubarIcon} alt="Menu Icon" className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
      {/* Drawer */}
      <div className={`fixed top-0 left-0 h-full w-[200px] max-h-[939px] lg:max-h-[965px] transition-transform duration-300 transform ${isDrawerOpen ? 'translate-x-0' : '-translate-x-full'} bg-white shadow-lg z-50`}>
        <button className="absolute top-4 right-4 text-[#475467]" onClick={toggleDrawer}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="https://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <nav className="mt-16 flex flex-col items-start gap-4 px-4">
          <Link to="/repair-gadget" className={`text-[#475467] font-plus-jakarta-sans text-sm leading-6 ${location.pathname === '/repair-gadget' ? 'font-bold' : ''}`}>
            Repair
          </Link>
          <a href="/care-flow" className={`text-[#475467] font-plus-jakarta-sans text-sm leading-6 ${location.pathname === '/care-flow' ? 'font-bold' : ''}`}>Care</a>
          <a href="#about-us" className="text-[#475467] font-plus-jakarta-sans font-semibold text-sm leading-6">About Us</a>
          {/* <a href="/contact-us" className="text-[#475467] font-plus-jakarta-sans font-semibold text-sm leading-6">Contact Us</a> */}
          <Link to="/contact-us" className="text-[#475467] font-plus-jakarta-sans text-sm lg:text-base leading-6">Contact Us</Link> {/* Updated to Link */}

          {!hideAuthButtons && (
            <>
              {/* <a href="#login" className="text-[#475467] font-plus-jakarta-sans text-sm font-semibold lg:text-base leading-6">Log in</a>
              <a href="#signup" className="bg-yellow-400 font-plus-jakarta-sans text-black text-sm lg:text-base leading-6 py-[10px] px-4 rounded-xl">Sign up</a> */}
            </>
          )}
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
